export const OtpErrorMessages: any = {
    exception:
        'We encountered an error while sending you the code. Please try logging in again or contact us',
    exhausted_attempts:
        'You have exceeded the limit to request a two factor authentication code. Your account is locked. Please email contact@playoctopus.com to unlock your account',
    code_reuse:
        'The submitted code has expired. Please resend the code and try again.',
    invalid_code:
        'The entered code is invalid. Please resend the code and try again.',
    message_sent: 'The code has been sent to your number.',
    number_unsubscribed:
        'Unable to send verification text (error code: UNSUBSCRIBED). Please text JOIN to 21555 to re-subscribe to verification texts. After re-subscribing, request a code and it should arrive within 5 minutes. Still have questions? <a href="mailto:contact@playoctopus.com">contact@playoctopus.com</a>',
    could_not_send:
        'We couldn’t send the message to your phone number. Please submit a screenshot of this error message to our support team at: contact@playoctopus.com.',
    second_attempt:
        'Oops! Your account will be locked out soon due to multiple failed login attempts. Please be extra careful when typing in the verification code you received. If the verification code still does not work, please contact us at: https://playoctopus.com/help',
    invalid_contact:
        'Oops! Your cellphone carrier blocked the verification code message. Please contact our support team for further assistance at: playoctopus.com/help.',
};
